import Subsection from "../Subsection";
import styles from "./featuredIn.module.scss";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
import Ticker from "@Components/Ticker";
import Image from "@Components/Image";
import { SCREEN_SIZE, useResponsiveness } from "hooks/useResponsiveness";
import { useState } from "react";

interface FeaturedInProps {
  isDesktop?: boolean;
}

const FeaturedIn = ({ isDesktop = false }: FeaturedInProps) => {
  const { t } = useTranslationHook();
  const { isAbove } = useResponsiveness();
  const isAboveMD = isAbove(SCREEN_SIZE.MD, false);
  const showForDesktop = isDesktop && isAboveMD;
  const [loaded, setLoaded] = useState<Set<number>>(new Set());

  const partnerLogos: any = [
    "fin-exp.png",
    "eco-times.png",
    "invezz.png",
    "yourstory.png",
    "outlook-biz.png",
    "cnbc.png",
  ];

  const handleImageLoad = (index: number) => {
    setLoaded((prev) => new Set(prev).add(index));
  };

  partnerLogos.forEach((_l: any, index: any, arr: any) => {
    const isLoaded = loaded?.has(index);
    partnerLogos[index] = (
      <Image
        src={`https://prod-static-assets.amberstudent.com/images/featured-in/${arr[index]}`}
        alt={arr[index]}
        width="120px"
        height="auto"
        className={styles.logo}
        addShimmer={!isLoaded}
        onLoad={() => handleImageLoad(index)}
        isAutoScroll
        autoScrollIndex={index}
      />
    );
  });

  // duplicate the elements to cover full width (logo<8)
  const extPartnerLogos = [...partnerLogos, ...partnerLogos];

  return (
    <>
      <Subsection title={t("home.featuredin.featuredtitle")} isDesktop={showForDesktop} greyBg>
        <Ticker items={extPartnerLogos} />
      </Subsection>
    </>
  );
};

export default wrapperHOC(FeaturedIn, {
  componentName: "FeaturedIn-Home",
  showForChina: true,
});
